import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { bool, func } from "prop-types";
import { Alert, Button } from "@icg360/ui-toolkit";
import RulesetIndicator from "../../shared/components/RulesetIndicator";
import { pacDataPropTypes } from "../../shared/propTypes";
import { APP_IDS } from "../../constants";
var AGENT_PORTAL = APP_IDS.AGENT_PORTAL; // Should match the `state` key for the form value in <Edit />

var name = "overrideRulesetBlockers";

var RulesetBlockerOverride = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RulesetBlockerOverride, _Component);

  function RulesetBlockerOverride() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleOnChange = function () {
      var _this$props = _this.props,
          updateFormValue = _this$props.updateFormValue,
          value = _this$props.value;
      updateFormValue(name, !value);
    };

    return _this;
  }

  var _proto = RulesetBlockerOverride.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        applicationId = _this$props2.pacData.applicationId,
        value = _this$props2.value;
    return applicationId === AGENT_PORTAL ? /*#__PURE__*/React.createElement(Alert, {
      bsStyle: "danger"
    }, /*#__PURE__*/React.createElement(RulesetIndicator, null), ": This request is being prevented by this product\u2019s underwriting guidelines. Contact Policy Services for help processing this request.") : /*#__PURE__*/React.createElement(Alert, {
      bsStyle: value ? "warning" : "danger"
    }, /*#__PURE__*/React.createElement(Button, {
      style: {
        float: "right",
        marginTop: "-7px",
        marginLeft: "7px"
      },
      onClick: this.handleOnChange,
      bsStyle: value ? "default" : "danger"
    }, value ? "Refuse" : "Approve", " Exception Request"), /*#__PURE__*/React.createElement(RulesetIndicator, null), " in order to continue processing changes.");
  };

  return RulesetBlockerOverride;
}(Component);

RulesetBlockerOverride.propTypes = {
  pacData: pacDataPropTypes.isRequired,
  updateFormValue: func.isRequired,
  value: bool.isRequired
};
export { RulesetBlockerOverride as default };